var imageZoom = function () {
    var mainImage = document.getElementById('main-image'),
        lens = document.getElementById('lens'),
        zoomImageDiv = document.getElementById('zoom-image'),
        zoomImageWidth = 0,
        zoomImageHeight = 0,
        zoomNoImage = false;

    if (mainImage && zoomImageDiv) {
        getZoomImageDimensions(mainImage);

        var zoomImageUrl = mainImage.getAttribute('data-zoom-image');

        if (zoomImageUrl.search('noimage') !== -1) {
            zoomNoImage = true;
        } else {
            zoomImageDiv.style.backgroundImage = 'url(' + zoomImageUrl + ')';
        }

        mainImage.addEventListener('mouseover', showZoomImage);
        mainImage.addEventListener('mouseout', hideZoomImage);
        mainImage.addEventListener('mousemove', moveZoomImage);
    }

    var productThumbsDiv = document.getElementById('product-thumbnails');
    if (productThumbsDiv) {
        var productThumbnails = productThumbsDiv.getElementsByClassName('product-thumbnail-link');

        for (var i = 0; i < productThumbnails.length; i++) {
            productThumbnails[i].addEventListener('click', onProductThumbClick);
        }
    }

    function onProductThumbClick(e) {
        e.preventDefault();
        getZoomImageDimensions(this);

        var mainImageUrl = this.getAttribute('href');
        var zoomImageUrl = this.getAttribute('data-zoom-image');

        mainImage.setAttribute('src', mainImageUrl);
        zoomImageDiv.style.backgroundImage = 'url(' + zoomImageUrl + ')';
        zoomNoImage = false;
    }

    function getZoomImageDimensions(element) {
        var source = element.getAttribute('data-zoom-image');
        var imgClone = document.createElement("img");
        imgClone.src = source;

        imgClone.onload = function() {
            zoomImageWidth = imgClone.width;
            zoomImageHeight = imgClone.height;
        };
    }

    function showZoomImage() {
        // on XS, SM - zoom not visible.
        if (isMobileSizeXsSm() == true || zoomNoImage) {
            return;
        }

        zoomImageDiv.style.display = 'block';
    }

    function hideZoomImage() {
        zoomImageDiv.style.removeProperty('display');
    }

    function moveZoomImage(e) {
        if (isMobileSizeXsSm() == true) {
            return;
        }

        var imgWidth = mainImage.width;
        var imgHeight = mainImage.height;
        var coords = this.getBoundingClientRect();
        var zoomImageDivStyle = window.getComputedStyle(zoomImageDiv);

        var zoomImageDivWidth = zoomImageDivStyle.width.replace('px', '');
        var zoomImageDivHeight = zoomImageDivStyle.height.replace('px', '');

        var scaleX = zoomImageWidth / imgWidth;
        var scaleY = zoomImageHeight / imgHeight;
        var lensWidth = zoomImageDivWidth / scaleX;
        var lensHeight = zoomImageDivHeight / scaleY;

        var lensLeft = (e.pageX - coords.left) - lensWidth/2;
        var lensTop = (e.clientY - coords.top) - lensHeight/2;

        if (lensLeft < 0) {
            lensLeft = 0;
        } else if ((lensLeft + lensWidth) > imgWidth) {
            lensLeft = imgWidth - lensWidth;
        }

        if (lensTop < 0) {
            lensTop = 0;
        } else if ((lensTop + lensHeight) > imgHeight) {
            lensTop = imgHeight - lensHeight;
        }

        lens.style.width = lensWidth + 'px';
        lens.style.height = lensHeight + 'px';
        lens.style.left = lensLeft + 'px';
        lens.style.top = lensTop + 'px';

        var zoomX = zoomImageWidth * lensLeft / imgWidth;
        var zoomY = zoomImageHeight * lensTop / imgHeight;

        zoomImageDiv.style.backgroundPositionX = '-' + Math.round(zoomX) + 'px';
        zoomImageDiv.style.backgroundPositionY = '-' + Math.round(zoomY) + 'px';
    }

    function isMobileSizeXsSm() {
        return window.matchMedia('(max-width: 992px)').matches;
    }
}();
